module.exports = __webpack_public_path__ + "static/img/容器 57@1x.8ac0860c.png";